// src/components/CsvButton.tsx
import type { CSSProperties } from "react";
import { downloadCsv } from "../lib/csv";

export function CsvButton({
  rows, filename, columns, label = "CSV", style,
}: {
  rows: Record<string, unknown>[];
  filename: string;
  columns?: string[];
  label?: string;
  style?: CSSProperties;
}) {
  if (rows.length === 0) return null;
  return (
    <button
      onClick={() => downloadCsv(rows, filename, columns)}
      className="no-print text-[10px] px-2 py-0.5 rounded border border-slate-300 text-slate-600 hover:bg-slate-50"
      title={`${rows.length} 行を CSV ダウンロード`}
      style={style}
    >⬇ {label}</button>
  );
}
